module.exports = __webpack_public_path__ + "static/media/pfbg_992@2x.1423e11e.jpg";